if (!customElements.get('rotating-word')) {
  customElements.define(
    'rotating-word',
    class RotatingWord extends HTMLElement {
      connectedCallback() {
        this.words = Array.from(this.querySelectorAll('.hero-text__rotator-word'));
        if (this.words.length < 2) return;

        this.index = 0;
        this.activate(this.words[this.index]);

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const interval = parseInt(this.dataset.interval, 10) || 2500;
        this.timer = setInterval(() => this.rotate(), interval);
      }

      // Broadcasts the newly active word (and its index) so sibling
      // elements in the same section — e.g. a hero photo slider — can
      // mirror it without a direct DOM coupling to this element's internals.
      activate(word) {
        word.classList.add('is-active');
        this.dispatchEvent(new CustomEvent('rotating-word:change', { bubbles: true, detail: { index: this.index, text: word.textContent } }));
      }

      rotate() {
        const current = this.words[this.index];
        this.index = (this.index + 1) % this.words.length;
        const next = this.words[this.index];

        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        this.activate(next);

        setTimeout(() => current.classList.remove('is-leaving'), 400);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }
    }
  );
}
